/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./index.less");

var _tool = require("../../../../utils/tool");

var _config = require("../../../../utils/config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)("div", {
    className: "charge-tit"
}, void 0, "\u5B9E\u65F6\u6570\u636E\uFF1A");

var _ref2 = (0, _jsx3.default)("div", {
    className: "equipment-fault-tit"
}, void 0, "\u6545\u969C\u4FE1\u606F");

var _ref3 = (0, _jsx3.default)("li", {
    className: "equipment-fault-header"
}, void 0, (0, _jsx3.default)("span", {}, void 0, "\u5E8F\u53F7"), (0, _jsx3.default)("span", {}, void 0, "\u6545\u969C"), (0, _jsx3.default)("span", {}, void 0, "\u72B6\u6001"));

var Secondary = function (_Component) {
    (0, _inherits3.default)(Secondary, _Component);

    function Secondary() {
        (0, _classCallCheck3.default)(this, Secondary);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Secondary.__proto__ || (0, _getPrototypeOf2.default)(Secondary)).call(this));

        _this.state = {
            detailOBJ: [{
                title: '固件版本',
                key: 'firmwareVersion',
                val: ''
            }],
            secondarys: []
        };
        return _this;
    }
    /*2019.8.22*/


    (0, _createClass3.default)(Secondary, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            this.handleGetList();
            this.handleFault();
        }
    }, {
        key: "handleGetList",
        value: function handleGetList() {
            var _this2 = this;

            (0, _tool.http)(_config.apiJson.getCabinetViceEdgeInfo, this.props || {}).then(function (res) {
                var result = res || {};
                _this2.state.detailOBJ.forEach(function (item) {
                    item.val = result[item.key] || result[item.key] == 0 ? result[item.key] : '--';
                });

                _this2.setState({
                    detailOBJ: _this2.state.detailOBJ
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? "" + res : res.errmsg;
                message.error(msg);
            });
        }

        // 故障列表

    }, {
        key: "handleFault",
        value: function handleFault() {
            var _this3 = this;

            (0, _tool.http)(_config.apiJson.getCabinetViceFaultInfo, this.props || {}).then(function (res) {
                _this3.setState({
                    secondarys: res || []
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? "" + res : res.errmsg;
                message.error(msg);
            });
        }

        /*------------------------------*/

    }, {
        key: "render",
        value: function render() {
            return (0, _jsx3.default)("div", {
                className: "secondary"
            }, void 0, (0, _jsx3.default)("div", {
                className: "charge-realtime"
            }, void 0, _ref, (0, _jsx3.default)("div", {
                className: "charge-datas"
            }, void 0, this.state.detailOBJ.map(function (res, i) {
                return (0, _jsx3.default)("div", {
                    className: "charge-xx"
                }, i, res.title, ":", res.val);
            }))), (0, _jsx3.default)("div", {
                className: "equipment-fault"
            }, void 0, _ref2, (0, _jsx3.default)("ul", {
                className: "equipment-fault-info"
            }, void 0, _ref3, this.state.secondarys.map(function (res, i) {
                return (0, _jsx3.default)("li", {
                    className: "equipment-fault-footer"
                }, i, (0, _jsx3.default)("span", {}, void 0, i + 1, ". "), (0, _jsx3.default)("span", {}, void 0, _tool.filter.faultInfo(res.function), " "), (0, _jsx3.default)("span", {}, void 0, res.status === 0 ? '正常' : '异常'));
            }))));
        }
    }]);
    return Secondary;
}(_react.Component);

exports.default = Secondary;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/sbDevice/batteryInfo/secondarySide/index.jsx
// module id = 1562
// module chunks = 0